import { render, staticRenderFns } from "./BudgetManager.vue?vue&type=template&id=6554cbed&"
import script from "./BudgetManager.vue?vue&type=script&lang=ts&"
export * from "./BudgetManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports